export const publicPaths = {
  home: '/',
  login: '/login',
  resetPassword: '/auth/reset',
  confirm: '/auth/confirm',
  tariffs: '/tariffs',
  price: '/price',
  about: '/about',
  agreements: '/agreements',
  storeOffer: '/store-offer',
  userAgreements: '/user-agreements',
  privacy: '/privacy',
  cookies: '/cookies',
  mitLicenseTerms: '/mit-license-terms',
  contact: '/contact',
  partners: '/partners',
  iosPwa: '/ios-pwa',
  error: '/error/:code',
} as const

export const profilePathPrefixes = {
  recommendations: '/recommendations',
  aiTools: '/ai-tools',
  cardSets: '/card-sets',
  favoriteCardSets: '/card-sets-favorite',
  folders: '/folders',
  favoriteFolders: '/folders-favorite',
  settings: '/settings',
  search: '/search',
  subscription: '/subscription',
  reviewHistory: '/review-history',
  scheduledReviewHistory: '/scheduled-review-history',
  firstRound: '/first-round-repetition',
  secondRound: '/second-round-repetition',
  thirdRound: '/third-round-repetition',
  partner: '/partner',
  user: '/user',
  orderList: '/order-list',
  groups: '/group',
  participatingGroups: '/group-participating',
  repetition: '/repetition',
  scheduledRepetition: '/repetition/scheduled',
  knowledgeMap: '/knowledge-map',
  invite: '/invite',
  store: '/store',
  referrals: '/referrals',
  myProducts: '/my-products',
  sellerProducts: '/store/seller/products',
  sellerMaterials: '/store/seller/materials',
  productAutomationAdmin: '/admin/product-automation',
} as const

export const allSupportedPathPrefixes = [
  ...Object.values(publicPaths),
  ...Object.values(profilePathPrefixes),
] as const
